import React, { useState, useEffect } from "react";
import { isEmpty } from "lodash";
import { OverlayTrigger, Tooltip, Row, Col } from "react-bootstrap";
import { usCurrency } from "../../utils";

const AddTreeStructure = (props) => {
  const { data, style = {} } = props;
  const [isOpen, setOpen] = useState([]);
  useEffect(() => {
    setOpen(
      data.map((_) => {
        return false;
      })
    );
  }, [data]);

  return (
    <ul style={style} className="tree">
      {data?.map((item, index) => {
        return (
          <li>
            <div
              style={{
                fontSize: "14px",
                fontWeight: "400",
                marginLeft: "-25px",
                color: "#307BF6",
              }}
            >
              <i
                onClick={() =>
                  setOpen(
                    isOpen.map((data, i) => {
                      if (i == index) {
                        return !data;
                      }
                      return data;
                    })
                  )
                }
                className={`${
                  isOpen[index] ? "far fa-minus-square" : "far fa-plus-square"
                }`}
              ></i>
              {item.head}
            </div>
            <div
              className="fw-500"
              style={{
                fontSize: "14px",
                float: "right",
                marginTop: "-30px",
                marginRight: "-35px",
              }}
            >
              {usCurrency(item.amount)}
            </div>
            {isOpen[index] && (
              <ul>
                {item.subHead?.map((subHead, index) => {
                  return (
                    <li style={{ justifyContent: "space-between" }}>
                      <div style={{ marginLeft: "-25px" }}>{subHead.name}</div>
                      <div
                        style={{
                          float: "right",
                          marginTop: "-30px",
                          marginRight: "-40px",
                          color: "#646464",
                          marginRight: "-75px",
                        }}
                      >
                        {usCurrency(subHead.amount)}
                      </div>
                    </li>
                  );
                })}
              </ul>
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default AddTreeStructure;
